import Nullstack from 'nullstack';
export default function IconWalk({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-walk",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "13",
    cy: "4",
    r: "1"
  }), "   ", Nullstack.element("line", {
    x1: "7",
    y1: "21",
    x2: "10",
    y2: "17"
  }), "   ", Nullstack.element("path", {
    d: "M16 21l-2 -4l-3 -3l1 -6"
  }), "   ", Nullstack.element("path", {
    d: "M6 12l2 -3l4 -1l3 3l3 1"
  }), " ");
}